/**
 * Map Laravel validation messages (often English) to i18n keys.
 */
export function localizeApiFieldError(field, rawMessage, t) {
    if (!rawMessage || typeof rawMessage !== "string") {
        return rawMessage;
    }
    const msg = rawMessage.toLowerCase();
    if (field === "email" && (msg.includes("already been taken") || msg.includes("has already been taken"))) {
        return t("existEmail");
    }
    if (field === "mobile" && (msg.includes("already been taken") || msg.includes("has already been taken"))) {
        return t("existMobile");
    }
    return rawMessage;
}
